import { __get } from '.';

/**
 * انتخاب کردن یک اسلایس از استیت کلی ریداکس
 * @param name - نام اسلایس استیت
 * @example <caption>برای مثال پیک کردن فیلد دیتا استیت سرویس ها</caption>
 * useSelector(select('services.data'), shallowEqual);
 * @returns فانکشنی را ریترن میکند که آن فانکشن استیت را از یوزسلکتور گرفته و اسلایس مورد نظر را ریترن میکند
 */
export const select = (name) => (state) => __get(state, name);
